import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-07aa139a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right" }
const _hoisted_2 = {
  key: 1,
  class: "img-container"
}
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "size" }

import Loader from "@/components/chat/chatContainer/Loader.vue";
import { getFileSize } from "@/utils/attachment";
import { getShortenedString } from "@/utils/modifiers";
import { Attachment, Message } from "@/store/chats/types";

import { computed } from "vue";
import { useI18n } from "vue-i18n";
import { getIsMyMessageClass } from "@/utils/chat";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";

interface Props {
  attachment: Attachment;
  message: Message;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'OtherAttachment',
  props: {
    attachment: {},
    message: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n();

const authId = useComputedValue<number>(GetterTypes.GET_AUTH_ID);
const shortenedFileName = computed<string>(() => {
  return getShortenedString(props.attachment.filename, 20);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["attachment-other", _unref(getIsMyMessageClass)(_ctx.message, _unref(authId))])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.attachment?.uploadProgress !== undefined && !_ctx.attachment?.uploaded)
        ? (_openBlock(), _createBlock(Loader, {
            key: 0,
            progress: _ctx.attachment.uploadProgress
          }, null, 8, ["progress"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(Icon, {
              icon: _unref(IconType).FILE
            }, null, 8, ["icon"])
          ]))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        class: "link",
        target: "_blank",
        href: _ctx.attachment?.url
      }, _toDisplayString(shortenedFileName.value || _unref(t)("chat.attachment")), 9, _hoisted_4),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(getFileSize)(_ctx.attachment?.size)), 1)
    ])
  ], 2))
}
}

})